import {
  ArrowBackRoundedIcon,
  Dialog,
  DialogTitle,
  Divider,
  Flex,
  IconButton,
} from '@shared/components';

import { CreateThirdProctorModalFormProvider, useProctoringDetailsModal } from '../../providers';
import { CreateThirdProctorForm } from '../create-third-proctor-form';

interface CreateThirdProctorModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function CreateThirdProctorModal(props: Readonly<CreateThirdProctorModalProps>) {
  const { isOpen, onClose } = props;
  const { setAction } = useProctoringDetailsModal();

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <CreateThirdProctorModalFormProvider>
        <DialogTitle onClose={onClose}>
          <Flex
            sx={{
              gap: (theme) => theme.spacing(4),
              alignItems: 'center',
            }}
          >
            <IconButton onClick={() => setAction({ action: 'add-proctor' })}>
              <ArrowBackRoundedIcon />
            </IconButton>
            เพิ่มผู้คุมสอบประเภทที่ 3
          </Flex>
        </DialogTitle>
        <Divider />
        <CreateThirdProctorForm onClose={onClose} />
      </CreateThirdProctorModalFormProvider>
    </Dialog>
  );
}
